import React, { forwardRef } from "react";
import { FaChevronDown } from "react-icons/fa";
import SetupStepRow from "./SetupStepRow";
import { GroupServices, ProgressBar, groupLabel } from "./setupUi";

/** One service group. When shown on its own (``collapsible`` false) it stays open with no toggle. */
const SetupCategory = forwardRef(function SetupCategory(
  { category, steps, open, selected, collapsible = true, onToggle, onOpenStep, isStaff = true },
  ref
) {
  const progress = category.Progress || { Pct: 0, Steps_Done: 0, Steps_Total: 0 };
  const bodyId = `dms-cat-${category.Category_Id}`;
  const isOpen = open || !collapsible;

  const headContent = (
    <>
      <span className="dmp-section__title dms-cat__title">
        <span className="dms-cat__name">
          {groupLabel(category)}
          <GroupServices services={category.Services} />
        </span>
        {category.Description ? <span className="dms-cat__desc">{category.Description}</span> : null}
      </span>
      <ProgressBar pct={progress.Pct} label={`${category.Name}: ${progress.Pct}% complete`} />
      <span className="dms-cat__count">
        {progress.Steps_Done}/{progress.Steps_Total} · {progress.Pct}%
      </span>
    </>
  );

  return (
    <section ref={ref} className={`dmp-section dms-cat${isOpen ? " is-open" : ""}${selected ? " is-selected" : ""}`}>
      {collapsible ? (
        <button
          type="button"
          className="dmp-section__head dms-cat__head"
          aria-expanded={isOpen}
          aria-controls={bodyId}
          onClick={onToggle}
        >
          {headContent}
          <span className="dmp-section__toggle">
            <FaChevronDown aria-hidden="true" />
          </span>
        </button>
      ) : (
        <div className="dmp-section__head dms-cat__head dms-cat__head--static">{headContent}</div>
      )}
      {isOpen ? (
        <div id={bodyId} className="dms-cat__body">
          {steps.length === 0 ? (
            <p className="dmp-muted dms-cat__empty">No steps match the filter.</p>
          ) : (
            steps.map((step) => (
              <SetupStepRow key={step.Tenant_Step_Id} step={step} onOpen={onOpenStep} isStaff={isStaff} />
            ))
          )}
        </div>
      ) : null}
    </section>
  );
});

export default SetupCategory;
